import { stringify } from 'qs'
import { apiService } from '../../../../'
import {
  ConfirmNewRequest,
  ConfirmNewResponse,
  CreditCardResponse,
  InitiateNewRequest,
  InitiateNewResponse,
  UpdatePreferredCreditCardRequest,
  UpdateCreditCardBillingAddressRequest,
  InitialReportCardCancellationResponse,
  ConfirmReportCardCancellationRequest,
  ConfirmReportCardCancellationResponse,
} from '../types'

const baseURL = '/portal/consumers/account/creditcards'

export const creditCardsService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getCreditCards: build.query<CreditCardResponse, void>({
      query: () => {
        return {
          url: baseURL,
          method: 'get',
        }
      },
      providesTags: ['CreditCards'],
    }),
    initiateNew: build.mutation<InitiateNewResponse, InitiateNewRequest>({
      query: (body) => ({
        url: `${baseURL}/initiate-new`,
        method: 'post',
        data: body,
      }),
    }),
    deleteCard: build.mutation<void, string>({
      query: (id) => ({
        url: `${baseURL}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['CreditCards'],
    }),
    updatePreferredCard: build.mutation<void, UpdatePreferredCreditCardRequest>({
      query: (req) => {
        const stringifiedParams = req.params.includingAgreements !== undefined ? stringify({ includingAgreements: req.params.includingAgreements }) : ''
        return {
          url: `${baseURL}/${req.params.id}/preferred?${stringifiedParams}`,
          method: 'put',
        }
      },
      invalidatesTags: (_res, _err, req) => ['CreditCards', ...req.cache.invalidatesTags],
    }),
    confirmNew: build.mutation<ConfirmNewResponse, ConfirmNewRequest>({
      query: (body) => ({
        url: `${baseURL}/confirm-new`,
        method: 'post',
        data: body,
      }),
      // Show error message
      invalidatesTags: (_res, _err, req) => {
        if (_err != null) {
          return []
        }
        return ['CreditCards', 'ConsumerAccount']
      },
    }),
    updateBillingAddress: build.mutation<void, UpdateCreditCardBillingAddressRequest>({
      query: (req) => ({
        url: `${baseURL}/${req.id}/address`,
        method: 'put',
        data: req.body,
      }),
      invalidatesTags: ['CreditCards'],
    }),
    initialReportCardCancellation: build.mutation<InitialReportCardCancellationResponse, void>({
      query: () => ({
        url: `${baseURL}/canceled/report`,
        method: 'get',
      }),
    }),
    confirmReportCardCancellation: build.mutation<ConfirmReportCardCancellationResponse, ConfirmReportCardCancellationRequest>({
      query: (data) => ({
        url: `${baseURL}/canceled/confirm`,
        method: 'post',
        data,
      }),
    }),
  }),
})
